import { DialogTitle, DialogTitleProps, Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { ModalWindowContext } from './ModalWindow';
import CloseIcon from '@material-ui/icons/Close';
import { useGlobalStyle } from '@utils/GlobalStyle';

export type ModalWindowTitleProps = DialogTitleProps & {
    icon?: React.ReactNode
    title: string
    hasCloseButton?: boolean
}

export function ModalWindowTitle ({ icon, title, hasCloseButton, ...props }: ModalWindowTitleProps) {
    const modalContext = React.useContext(ModalWindowContext);
    const cls = useStyles();
    const gcls = useGlobalStyle();

    const handleCloseButtonClick = React.useCallback(() => {
        if (modalContext !== undefined) {
            modalContext.close();
            
            if (modalContext.onModalClose !== undefined) {
                modalContext.onModalClose("closeButton");
            }
        }
    }, [modalContext]);

    return (
        <DialogTitle disableTypography className={cls.root} {...props}>
            <Grid container alignItems="center">
                {
                    icon !== undefined && (
                        <Grid item className={cls.icon}>{ icon }</Grid>
                    )
                }

                <Grid item><Typography>{ title }</Typography></Grid>

                {
                    modalContext !== undefined && hasCloseButton !== false && (
                        <Grid item className={gcls.floatRight}>
                            <IconButton className={cls.closeButton} onClick={handleCloseButtonClick}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    )
                }
            </Grid>

        </DialogTitle>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: 'rgba(0, 0, 0, .1)'
    },

    icon: {
        marginRight: theme.spacing(1), 
        marginTop: 5
    },

    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: 5,
        color: theme.palette.grey[500],
    },
}))
